import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ActiveJobBackground from "../../../../../assets/images/activeJobBackGround.png";
import { StyledDialog } from "../../../../common-components/StyledComponents";

const SendAssessmentDialog = ({
  open,
  onClose,
  onAdd,
  title,
  engineOptions = [], // Options for the first dropdown
  assessmentOptions = [], // Options for the second dropdown
  engineLabel = "Select Assessment Engine",
  assessmentLabel = "Search Assessment",
}) => {
  const [assessmentEngine, setAssessmentEngine] = useState(""); // State for first dropdown
  const [assessment, setAssessment] = useState(""); // State for second dropdown

  const handleAddClick = () => {
    onAdd({ engine: assessmentEngine, assessment });
    onClose();
  };

  return (
    <StyledDialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      {/* Background Image */}
      <img
        src={ActiveJobBackground}
        style={{ position: "absolute", width: "max-content", opacity: "0.7" }}
      />

      {/* Close Button */}
      <DialogActions>
        <Button onClick={onClose}>
          <CloseIcon />
        </Button>
      </DialogActions>

      {/* Dialog Title */}
      <DialogTitle>
        <Typography variant="h3" sx={{ mt: 2 }}>
          {title}
        </Typography>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent>
        <Grid container direction="column" gap={2}>
          {/* Dropdown 1: Assessment Engine */}
          <Grid item>
            <Typography
              color="#344054"
              fontSize={14}
              fontWeight={500}
              paddingBottom={"4px"}
            >
              {engineLabel}
            </Typography>
            <FormControl fullWidth>
              <Select
                value={assessmentEngine}
                onChange={(e) => setAssessmentEngine(e.target.value)}
                displayEmpty
                style={{
                  border: "1px solid #D0D5DD",
                  borderRadius: "8px",
                }}
              >
                <MenuItem value="" disabled>
                  {engineLabel}
                </MenuItem>
                {engineOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Dropdown 2: Assessment */}
          <Grid item>
            <Typography
              color="#344054"
              fontSize={14}
              fontWeight={500}
              paddingBottom={"4px"}
            >
              {assessmentLabel}
            </Typography>
            <FormControl fullWidth>
              <Select
                value={assessment}
                onChange={(e) => setAssessment(e.target.value)}
                displayEmpty
                style={{
                  border: "1px solid #D0D5DD",
                  borderRadius: "8px",
                  // padding: "8px",
                }}
              >
                <MenuItem value="" disabled>
                  {assessmentLabel}
                </MenuItem>
                {assessmentOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Add Button */}
          <Button
            fullWidth
            variant="contained"
            style={{
              // marginTop: "24px",
              backgroundColor: "#7F56D9",
              color: "#fff",
              borderRadius: "8px",
              padding: "10px",
              fontWeight: "600",
            }}
            onClick={handleAddClick}
          >
            Add
          </Button>
        </Grid>
      </DialogContent>
    </StyledDialog>
  );
};

export default SendAssessmentDialog;
